// extracted by mini-css-extract-plugin
export default {"DropdownContainer":"style_DropdownContainer__0k0b8","menu":"style_menu__kiT8P","menuBox":"style_menuBox__EeyrU"};